<template>
  <p>
    <span>
      {{ paymentMonths }} payments of
      <b>{{ $filters.toCurrency(monthlyPayment, price.currencyCode) }}</b> with
    </span>
    <img src="@/assets/images/payment-methods/klarna.svg" width="60" />
  </p>
</template>

<script>
export default {
  name: "Klarna",
  props: {
    price: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentMonths: 3,
    };
  },
  computed: {
    monthlyPayment() {
      return this.price.amount / this.paymentMonths;
    },
  },
};
</script>
